<template>
  <div class="sync-source-header">
    <div class="icon">
      <img v-if="source.typeInfo" :src="source.typeInfo.icon" :alt="source.typeInfo.product"/>
      <FileIcon v-else size="40"/>
    </div>
    <div class="name">{{ source.name }}</div>
    <div class="type">{{ source.typeInfo?.description ?? 'Unknown file' }}</div>
    <div class="detail">{{ location || source.subtitle }}</div>
    <div class="size" v-if="source.size != null">{{ sizeTextRef }}</div>
  </div>
</template>

<style lang="scss" scoped>
.sync-source-header {
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  column-gap: 0.75rem;
  grid-template-areas:
    "icon   name   ."
    "icon   type   ."
    "icon   detail size";
  align-items: start;

  .icon {
    grid-area: icon;
    display: flex;
    align-items: center;

    img {
      width: 60px;
    }
  }

  .name {
    grid-area: name;
    font-weight: 500;
  }

  .type {
    grid-area: type;
    font-size: 0.75rem;
    color: #aaa;
  }

  .detail {
    grid-area: detail;
    font-size: 0.75rem;
    color: #aaa;
    overflow-wrap: anywhere;
  }

  .size {
    grid-area: size;
    font-size: 0.875rem;
    color: #888;
  }
}
</style>

<script setup lang="ts">
import { computed } from 'vue'
import { FileIcon } from '@zhuowenli/vue-feather-icons'
import { ByteSizeUtil } from '@webapp/util/ByteSizeUtil'
import { SyncSourceInfo } from './SyncSessionModel'

const props = defineProps<{
  source: SyncSourceInfo
  location?: string
}>()

const sizeTextRef = computed(() => ByteSizeUtil.toReadableText(props.source.size))
</script>
